import Loading from 'Common/Components/Loading';
import GlobalLoader from 'Common/GlobalLoader';
import { LoadingProvider, useLoading } from 'Common/LoadingContext';
import Layout from 'Layout';
import NonAuthLayout from 'Layout/NonLayout';
import React, { Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { authProtectedRoutes, publicRoutes } from 'Routes/allRoutes';
import AuthProtected from 'Routes/AuthProtected';
import { appDispatch } from 'slices';
import { exChangeRateAPI } from 'slices/ecommerce/thunk';
import { LayoutHook } from 'slices/layouts/hook';
import { createCart } from 'slices/shoppingCart/reducer';
import './assets/scss/themes.scss';
// import fakeBackend from './helpers/AuthType/fakeBackend';

// fakeBackend();

function AppInner() {
  const dispatch = appDispatch();
  const { show, hide } = useLoading();
  const { pathname } = useLocation();
  const { loading } = LayoutHook();

  useEffect(() => {
    show();
    const id = setTimeout(() => hide(), 900);
    return () => clearTimeout(id);
  }, [pathname, show, hide]);

  useEffect(() => {
    if (loading) {
      show();
      return;
    }
    hide();
  }, [loading, show, hide]);

  useEffect(() => {
    Promise.allSettled([dispatch(exChangeRateAPI())]);
    const cart = localStorage.getItem('pending_orders');
    if (cart) {
      dispatch(createCart(JSON.parse(cart)));
      localStorage.removeItem('pending_orders');
    }
  }, [dispatch]);

  return (
    <React.Fragment>
      <GlobalLoader />
      <Suspense fallback={<Loading />}>
        <Routes>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <AuthProtected>
                  <Layout>
                    <route.component />
                  </Layout>
                </AuthProtected>
              }
            />
          ))}
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              key={idx}
              element={
                route.path === '/' ? (
                  <NonAuthLayout>
                    <Layout>
                      <route.component />
                    </Layout>
                  </NonAuthLayout>
                ) : (
                  <NonAuthLayout>
                    <route.component />
                  </NonAuthLayout>
                )
              }
            />
          ))}
        </Routes>
      </Suspense>
    </React.Fragment>
  );
}

export default App;

function App() {
  return (
    <LoadingProvider>
      <AppInner />
    </LoadingProvider>
  );
}
